<ng-container *ngIf="isVisible">
  <div class="controlling-persons-container pr-0 pl-0">
    <div class="d-flex">
      <div class="pr-0 pl-0" [ngClass]="{ 'col-12 col-lg-8': isShowDescription, 'col-12': !isShowDescription }">
        <div
          class="controlling-persons-container__person"
          *ngFor="let group of personsArray.controls; let i = index; trackBy: trackByGroup"
        >
          <span class="controlling-persons-container__header">
            <span class="controlling-persons-container__header-title">
              {{ headingKey | translate : { n: i + 1 } }}
              <app-hint-tooltip-icon *ngIf="headerTooltipKey" [hint]="headerTooltipKey | translate"></app-hint-tooltip-icon>
            </span>
            <span class="controlling-persons-container__remove" *ngIf="showRemove(i)" (click)="requestRemove(i)">
              <img src="assets/icons/icon_trash.svg" />
            </span>
          </span>

          <div class="row">
            <div class="col-12 col-lg-6" [id]="'control-cpFirstName-' + i">
              <app-control-wrapper [errors]="nameErrors" [control]="group.get('firstName')">
                <label [for]="'cpFirstName-' + i" control-label>
                  {{ "LABELS.FIRST_NAME" | translate }}
                </label>
                <input
                  type="text"
                  [formControl]="group.get('firstName')"
                  class="form-control"
                  [id]="'cpFirstName-' + i"
                  [name]="'cpFirstName-' + i"
                  autocomplete="chrome-off"
                  [placeholder]="'LABELS.FIRST_NAME' | translate"
                  [dropSpecialCharacters]="false"
                  [patterns]="CUSTOM_MASK"
                  [mask]="'N{50}'"
                  [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                  [maxMaskLength]="50"
                  control-wrapper
                />
              </app-control-wrapper>
            </div>
            <div class="col-12 col-lg-6" [id]="'control-cpLastName-' + i">
              <app-control-wrapper [errors]="nameErrors" [control]="group.get('lastName')">
                <label [for]="'cpLastName-' + i" control-label>
                  {{ "LABELS.LAST_NAME" | translate }}
                </label>
                <input
                  type="text"
                  [formControl]="group.get('lastName')"
                  class="form-control"
                  [id]="'cpLastName-' + i"
                  [name]="'cpLastName-' + i"
                  autocomplete="chrome-off"
                  [placeholder]="'LABELS.LAST_NAME' | translate"
                  [dropSpecialCharacters]="false"
                  [patterns]="CUSTOM_MASK"
                  [mask]="'N{50}'"
                  [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH'"
                  [maxMaskLength]="50"
                  control-wrapper
                />
              </app-control-wrapper>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-lg-6" [id]="'control-cpSocialSecurityNumber-' + i">
              <app-control-wrapper [errors]="ssnErrors" [control]="group.get('socialSecurityNumber')">
                <label [for]="'cpSocialSecurityNumber-' + i" control-label>
                  {{ "COMPANY.CONTROLLING_PERSONS.SSN_LABEL" | translate }}
                </label>
                <input
                  type="text"
                  [formControl]="group.get('socialSecurityNumber')"
                  class="form-control"
                  [id]="'cpSocialSecurityNumber-' + i"
                  [name]="'cpSocialSecurityNumber-' + i"
                  autocomplete="chrome-off"
                  placeholder="NNN-NN-NNNN"
                  inputmode="numeric"
                  mask="000-00-0000"
                  [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS'"
                  control-wrapper
                />
              </app-control-wrapper>
            </div>
          </div>

          <div class="controlling-persons-container__upload">
            <document-upload-image
              [inputId]="'state-id-input-' + i"
              [downloadLink]="scanDownloadLink(group)"
              [isLoading]="isScanLoading(group)"
              [isShowLoader]="false"
              [headerLabel]="'COMPANY.CONTROLLING_PERSONS.STATE_ID'"
              [badgeLabel]="'LABELS.REQUIRED'"
              [badgeClass]="'required-badge'"
              [descriptionHint]="'COMPANY.CONTROLLING_PERSONS.UPLOAD_STATE_ID_HINT'"
              [uploadedFileLabel]="'COMPANY.CONTROLLING_PERSONS.STATE_ID'"
              [showRemoveButton]="false"
              [isNonImageDocument]="isScanNonImage(group)"
              [fileName]="scanFileName(group)"
              (upload)="onUploadScan(group, $event)"
            ></document-upload-image>
            <div class="controlling-persons-container__upload-error" *ngIf="scanErrorKey(group)">
              <span>{{ scanErrorKey(group) | translate }}</span>
              <span class="controlling-persons-container__upload-error-retry" (click)="onRetryScan(group)">
                {{ "COMPANY.CONTROLLING_PERSONS.RETRY_UPLOAD" | translate }}
              </span>
            </div>
          </div>

          <!-- #13281 — the control-wrapper renders the red required state (same as the MI "I declare" checkbox) -->
          <div class="controlling-persons-container__checkbox" [id]="'control-cpIsUsCitizenOrResident-' + i">
            <app-control-wrapper [errors]="citizenErrors" [control]="group.get('isUsCitizenOrResident')" [isShowHelper]="false">
              <div control-wrapper class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  [formControl]="group.get('isUsCitizenOrResident')"
                  class="custom-control-input"
                  [id]="'cpIsUsCitizenOrResident-' + i"
                />
                <label class="custom-control-label" [for]="'cpIsUsCitizenOrResident-' + i">
                  {{ "COMPANY.CONTROLLING_PERSONS.CITIZEN_CHECKBOX" | translate }}
                </label>
              </div>
            </app-control-wrapper>
          </div>
        </div>

        <button type="button" class="controlling-persons-container__add-button" (click)="addPerson()">
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
          {{ addButtonKey | translate }}
        </button>
      </div>
      <div class="d-none d-lg-block col-4" *ngIf="isShowDescription">
        <div class="controlling-persons-container-description">
          <span>{{ infoPanelKey | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <custom-modal [header]="'COMPANY.CONTROLLING_PERSONS.REMOVE_CONFIRM_HEADER'" [open]="isRemoveConfirmOpen" (openChange)="cancelRemove()">
    <p [innerHTML]="'COMPANY.CONTROLLING_PERSONS.REMOVE_CONFIRM_TEXT' | translate"></p>

    <button footer-action type="button" class="btn btn-secondary" (click)="cancelRemove()">{{ "BUTTON.CANCEL" | translate }}</button>

    <button footer-action type="button" class="btn btn-primary ml-2" (click)="confirmRemove()">
      {{ "BUTTON.DELETE" | translate }}
    </button>
  </custom-modal>
</ng-container>
